import { useContext } from 'react';

import type { GenericContextType } from '../../types/generic-context';

import { GenericContext } from '../constants';

export const useGenericContext = () => useContext(GenericContext) as GenericContextType;
